import { render, staticRenderFns } from "./botmarksentry.vue?vue&type=template&id=61065dd7&"
import script from "./botmarksentry.vue?vue&type=script&lang=js&"
export * from "./botmarksentry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports